import { c as _c } from "react/compiler-runtime";
import type { IPolicySummary } from '@/interfaces';
import type { FC } from 'react';
export const PolicyTypesLabel: FC<{
  types?: IPolicySummary['types'];
}> = t0 => {
  const $ = _c(7);
  const {
    types
  } = t0;
  if (!types?.length) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <>-</>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== types) {
    const lines = types.map(_temp);
    t1 = new Set(lines);
    $[1] = types;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = [...t1];
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const unique = t2;
  const t3 = unique.join(", ");
  let t4;
  if ($[5] !== t3) {
    t4 = <>{t3}</>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
function _temp(type) {
  return type.parent ? type.parent.label : type.label;
}